
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g/teams",
      function () {
        return require("private-next-pages/g/teams/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g/teams"])
      });
    }
  